import { render, staticRenderFns } from "./GridFormPart.vue?vue&type=template&id=72469788&scoped=true"
import script from "./GridFormPart.vue?vue&type=script&lang=js"
export * from "./GridFormPart.vue?vue&type=script&lang=js"
import style0 from "./GridFormPart.vue?vue&type=style&index=0&id=72469788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72469788",
  null
  
)

export default component.exports